/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const Template = (props) => {
  const { facetPlanOutcomeSummaryViewCollection, initializingError, isInitializing } = usePageContentContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: facetPlanOutcomeSummaryViewCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default Template;
